import { Typography } from 'components';

import { camelize } from 'humps';

function sortingIcon(key, cSortAttribute, sortOrder) {
  if (key != cSortAttribute) return 'ticon-up-down';
  if (sortOrder == 'desc') return 'ticon-down';
  return 'ticon-up';
}

export default function THead(props) {
  const {
    attributeCb,
    children,
    className,
    keys,
    labels,
    sortableKeys,
    sortAttribute,
    sortOrder,
    columnWidths = {},
    styleTh = {}
  } = props;

  if (!keys) return null;

  const cSortableKeys = sortableKeys?.map((k) => camelize(k)),
    cSortAttribute = sortAttribute ? camelize(sortAttribute) : null;

  const columnStyle = (key) => {
    if (key && columnWidths[key]) return columnWidths[key];

    return 0;
  };

  const stylingTh = (key) => {
    if (key && styleTh[key]) return styleTh[key];

    return {};
  };

  return (
    <thead className={className}>
      <tr>
        {keys.map((key) => (
          <th
            key={`thead-th-${key}`}
            className="h-12 !bg-primary-blue-100"
            // style={stylingTh(key)}
            onClick={attributeCb}
          >
            <div style={{ width: columnStyle(key) }} />
            <div className="align-center flex justify-between ">
              <Typography variant="medium4" className="truncate_line">
                {labels(key)}
              </Typography>
              {sortableKeys && cSortAttribute && sortOrder && cSortableKeys.includes(key) ? (
                <span className={`ml-2 ${sortingIcon(key, cSortAttribute, sortOrder)}`} />
              ) : null}
            </div>
          </th>
        ))}
        {children}
      </tr>
    </thead>
  );
}
